/**
 * Attribution tracking constants
 */

// Storage key for localStorage
export const ATTRIBUTION_STORAGE_KEY = "avante_attribution";

// Attribution window in days (30 days)
export const ATTRIBUTION_WINDOW_DAYS = 30;

// UTM parameter names
export const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
] as const;

export type UtmParam = (typeof UTM_PARAMS)[number];

// Known referrer domain to source mappings
export const REFERRER_SOURCE_MAP: Record<string, string> = {
  // Social platforms
  "tiktok.com": "tiktok",
  "www.tiktok.com": "tiktok",
  "vm.tiktok.com": "tiktok",
  "instagram.com": "instagram",
  "www.instagram.com": "instagram",
  "l.instagram.com": "instagram",
  "facebook.com": "facebook",
  "www.facebook.com": "facebook",
  "m.facebook.com": "facebook",
  "l.facebook.com": "facebook",
  "fb.me": "facebook",
  "twitter.com": "twitter",
  "www.twitter.com": "twitter",
  "t.co": "twitter",
  "x.com": "twitter",
  "linkedin.com": "linkedin",
  "www.linkedin.com": "linkedin",
  "youtube.com": "youtube",
  "www.youtube.com": "youtube",
  "youtu.be": "youtube",
  // Search engines
  "google.com": "google",
  "www.google.com": "google",
  "google.es": "google",
  "google.com.mx": "google",
  "google.com.ec": "google",
  "google.com.co": "google",
  "google.com.ar": "google",
  "bing.com": "bing",
  "www.bing.com": "bing",
  "duckduckgo.com": "duckduckgo",
  "yahoo.com": "yahoo",
  "search.yahoo.com": "yahoo",
  // Your own domains (WordPress)
  "comunidad.fit": "wordpress",
  "www.comunidad.fit": "wordpress",
};

// Medium detection based on source
export const SOURCE_MEDIUM_MAP: Record<string, string> = {
  tiktok: "social",
  instagram: "social",
  facebook: "social",
  twitter: "social",
  linkedin: "social",
  youtube: "social",
  google: "organic",
  bing: "organic",
  duckduckgo: "organic",
  yahoo: "organic",
  wordpress: "referral",
};

// Sources that indicate paid traffic (when no utm_medium is present)
export const PAID_INDICATORS = [
  "fbclid",
  "gclid",
  "ttclid",
  "msclkid",
] as const;

export const DRIP_QUERY_PARAMS = ["drip_email_id", "drip_step"] as const;

export const ATTRIBUTION_QUERY_PARAMS = [
  ...UTM_PARAMS,
  ...PAID_INDICATORS,
  ...DRIP_QUERY_PARAMS,
] as const;
